import dayjs from 'dayjs';
import prettify from 'html-prettify';
import cloneDeep from 'lodash/cloneDeep';

import { undefDestroy, UnescapeHtml } from '@webapp/common/lib/utils';

import type { Recipient } from './recipient';
import type { Sms, SmsGroup, SmsStatus, SmsType } from './smsing';
import { initialSms, initialSmsParams } from './smsing';

export const mapSms = ({
    FROM,
    ID,
    PARAMS,
    SURVEY_ID,
    STATUS,
    TYPE,
    START_TIME,
    WHO,
    IDENTIFICATION,
    READED_QNT,
    TEMPLATE,
    TOTAL_QNT,
    duplicate,
}: any): Sms => ({
    ...cloneDeep(initialSms),
    id: ID,
    duplicate,
    who: WHO, // ??? Возможно надо убрать тк приходит null
    surveyId: SURVEY_ID,
    senderSms: FROM,
    status: STATUS as SmsStatus,
    sendDatetime: dayjs.utc(START_TIME),
    smsType: TYPE as SmsType,
    bindSms: Boolean(IDENTIFICATION),
    smsAmount: TOTAL_QNT,
    template: TEMPLATE,
    replyAmount: READED_QNT,
    params: (() => {
        let params;

        try {
            params = JSON.parse(PARAMS);

            let fullHtml = UnescapeHtml(params.fullHtml);
            fullHtml = fullHtml.split('><').join(`>\n\t<`);
            fullHtml = prettify(fullHtml);
            params.fullHtml = fullHtml;
            params.expireDate = params.expireDate ? dayjs(params.expireDate) : undefined;
        } catch (e) {
            console.error(e);
            params = cloneDeep(initialSmsParams);
        }

        return params;
    })(),
});
export const reverseMapSms = ({ bindSms, senderSms, status, template, title, who }: Partial<Sms>): any =>
    undefDestroy({
        title,
        status,
        who,
        identification: typeof bindSms !== 'undefined' ? (bindSms ? 1 : 0) : undefined,
        from: senderSms,
        template,
    });

interface SmsGroupResponse {
    ID: number;
    NAME: string;
    PHONES: Array<{
        [key: string]: string;
    }>;
    HIDDEN: number;
}

export const mapGroup = ({ PHONES, HIDDEN, ID, NAME }: SmsGroupResponse): SmsGroup => ({
    id: ID,
    name: NAME,
    phones: PHONES,
    hidden: Boolean(HIDDEN),
});

export interface RecipientResponse {
    ID: number;
    RECIPIENT: string;
}

export const mapRecipient = ({ ID, RECIPIENT }: RecipientResponse): Recipient => ({
    id: ID,
    recipient: RECIPIENT,
});
